import React from 'react';
import * as S from './styles';

const TextArea = ({
  name,
  onChange,
  label,
  disabled,
  defaultValue,
  placeholder,
  tabIndex,
  helper,
  warning,
  className,
  children,
  rows,
  inputRef,
  required,
}: TextAreaProps) => (
  <S.InputWrapper className={className}>
    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
    <S.Label htmlFor={name}>
      <S.LabelText>{label}</S.LabelText>
      {children}
    </S.Label>

    <S.TextArea
      warning={warning}
      required={required}
      ref={inputRef}
      name={name}
      id={name}
      rows={rows}
      placeholder={placeholder}
      tabIndex={tabIndex}
      disabled={disabled}
      onChange={onChange}
      defaultValue={defaultValue}
    />

    <S.Helper warning={warning}>{helper}</S.Helper>
  </S.InputWrapper>
);

type TextAreaProps = {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  defaultValue?: string;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  tabIndex?: number;
  helper?: React.ReactNode;
  warning?: boolean;
  children?: React.ReactNode;
  rows?: number;
  inputRef?:
    | ((instance: HTMLTextAreaElement | null) => void)
    | React.RefObject<HTMLTextAreaElement>
    | null;
  required?: boolean;
};

TextArea.defaultProps = {
  label: null,
  defaultValue: undefined,
  onChange: () => {},
  disabled: false,
  placeholder: null,
  tabIndex: '0',
  helper: null,
  warning: false,
  className: null,
  children: null,
  rows: 4,
  inputRef: undefined,
  required: false,
};

export default TextArea;
